import { useContext, useEffect, useState, useCallback } from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { FormHelperText, TextField } from '@mui/material';
import { useField } from 'formik';
//Components
import { AuthContext } from 'context/auth-context';
//Services
import { Businesses } from 'lib/api';
//Utils and Helpers
import { GIFT_CARD_CATEGORY } from 'helpers/constants';
import { hasCreditModel } from 'helpers/businesses';
const filter = createFilterOptions();

export const CategoryInput = ({ variant, size, ...props }) => {
    const { businessInfo } = useContext(AuthContext);
    const [cardCategories, setCardCategories] = useState([]);
    const [field, meta, helpers] = useField(props);
    const { name, onBlur, value } = field;
    const { touched, error } = meta;
    const { setValue } = helpers;

    const fetchCardCategories = useCallback(async () => {
        try {
            const cardCategoryList = await Businesses.getCardCategories(businessInfo.id);
            let cardCategoryMap = cardCategoryList.map(cardCategory => ({
                value: cardCategory
            }));
            // Gift card should not be visible for credit model businesses
            if (hasCreditModel(businessInfo)) {
                cardCategoryMap = cardCategoryMap.filter(option => option.value !== GIFT_CARD_CATEGORY);
            }
            setCardCategories(cardCategoryMap);
        } catch (error) {
            console.error(error);
        }
    }, [businessInfo]);
    useEffect(() => {
        fetchCardCategories();
    }, [fetchCardCategories]);

    const handleChange = async (event, newValue) => {
        if (!newValue) {
            return setValue('');
        }
        if (typeof newValue === 'string') {
            return setValue(newValue?.value);
        }
        if (newValue && newValue?.inputValue) {
            // Create a new value from the user input
            await Businesses.createCardCategories(businessInfo.id, newValue.inputValue);
            return setValue(newValue.inputValue);
        }
        return setValue(newValue?.value);
    };

    const handleFilterOptions = (options, params) => {
        const filtered = filter(options, params);
        const { inputValue } = params;
        // Suggest the creation of a new value
        const isExisting = options.some(option => inputValue === option.value);
        if (inputValue !== '' && !isExisting) {
            filtered.push({
                inputValue,
                value: `Add "${inputValue}"`
            });
        }

        return filtered;
    };

    const handleGetOptionsLabel = option => {
        // Value selected with enter, right from the input
        if (typeof option === 'string') {
            return option;
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
            return option.inputValue;
        }
        // Regular options
        return option.value;
    };

    return (
        <>
            <Autocomplete
                clearOnBlur
                filterOptions={handleFilterOptions}
                freeSolo
                getOptionLabel={handleGetOptionsLabel}
                handleHomeEndKeys
                onChange={handleChange}
                options={cardCategories}
                renderOption={(props, option) => <li {...props}>{option.value}</li>}
                selectOnFocus
                renderInput={params => (
                    <TextField
                        {...params}
                        name={name}
                        variant={variant}
                        size={size}
                        error={touched && error}
                        onBlur={onBlur}
                        placeholder="Select a category or add new"
                    />
                )}
                value={value}
            />
            {touched && error && <FormHelperText error>{error}</FormHelperText>}
        </>
    );
};

export default CategoryInput;
